const videoEls = document.querySelectorAll( '.wp-block-video video' );

/**
 * Video protection
 * @description - Hide download option and disable right click on videos
 * @function
 * @name videoProtection
 * @return {void}
 */
const videoProtection = () => {

	if ( !videoEls.length ) {

		return;

	}

	videoEls.forEach( ( video ) => {

		video.setAttribute( 'controlsList', 'nodownload' );
		video.setAttribute( 'disablePictureInPicture', 'true' );

		if ( video.dataset.videoProtected === 'true' ) {

			return;

		}

		video.addEventListener( 'contextmenu', ( event ) => {

			event.preventDefault();

		} );

		video.dataset.videoProtected = 'true';

	} );

};

export { videoProtection };
